module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two_a@2x.210ae059.jpg";